import type { ComputedRef, InjectionKey } from 'vue'

import type { StatisticProps } from '@jdesign-vue/components/statistic'

export interface StatisticGroupContext {
  disabled?: StatisticProps['disabled']
  size?: StatisticProps['size']
  type?: StatisticProps['type']
  modelValue?: ComputedRef<StatisticProps['modelValue']>
  changeEvent?: (val: any) => void
}

export const statisticGroupContextKey: InjectionKey<StatisticGroupContext> =
  Symbol('statisticGroupContextKey')
